import { Helper } from '../Helper';
export class BindFunctionThisHelper extends Helper {
    constructor(options) {
        super();
        this.overwrite = options.overwrite;
    }
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            sb.emitOp(node, 'DROP');
            return;
        }
        let whenTrue;
        if (this.overwrite) {
            whenTrue = () => {
                sb.emitOp(node, 'SWAP');
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'SETITEM');
            };
        }
        else {
            whenTrue = () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
            };
        }
        sb.emitHelper(node, options, sb.helpers.cloneFunction);
        sb.emitOp(node, 'TUCK');
        sb.emitOp(node, 'DUP');
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'ARRAYSIZE');
                sb.emitPushInt(node, 3);
                sb.emitOp(node, 'NUMEQUAL');
            },
            whenTrue,
            whenFalse: () => {
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'APPEND');
            },
        }));
    }
}

//# sourceMappingURL=BindFunctionThisHelper.js.map
